// @flow
import React from 'react';
import DataTable from 'react-data-table-component';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { formatToIndianSystem } from 'utils/formatToIndianSystem';
import { formatUnixTimestamp } from 'utils/dateFormat';

function pitLogs({ data }) {
  const columns = [
    {
      name: 'Pit Number',
      selector: (row) => row.pitNumber,
    },
    {
      name: 'Vehicle Number',
      selector: (row) => row.vehicleNumber,
    },
    {
      name: 'Crusher Name',
      selector: (row) => row.customer,
    },
    {
      name: 'Auction Reference Number',
      selector: (row) => row.auctionReferenceNumber,
    },
    {
      name: 'Weighbridge Number from where vehicle entered',
      selector: (row) => (row.weighBridgeNumber !== '' ? row.weighBridgeNumber : '-'),
    },
    {
      name: 'Material Dispatched (in MT)',
      selector: (row) => formatToIndianSystem(row.materialDispatched),
    },
    {
      name: 'Price of the material dispatched (in Rupee)',
      selector: (row) => formatToIndianSystem(row.priceOfMaterial),
    },
    {
      name: 'Mine Area Entry Date and Time',
      selector: (row) => {
        return formatUnixTimestamp(row.loggedInTime);
      },
      sortable: true,
    },
    {
      name: 'Pit Entry Date and Time',
      selector: (row) => {
        if (row.guardCheckIn > 0) {
          return formatUnixTimestamp(row.guardCheckIn);
        }
        return '-';
      },
    },
    {
      name: 'Pit Exit Date and Time',
      selector: (row) => {
        if (row.guardCheckOut > 0) {
          return formatUnixTimestamp(row.guardCheckOut);
        }
        return '-';
      },
    },
    {
      name: 'Mine Area Exit Date and Time',
      selector: (row) => {
        if (row.loggedOutTime > 0) {
          return formatUnixTimestamp(row.loggedOutTime);
        }
        return '-';
      },
      sortable: true,
    },
  ];
  return (
    <Card>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Latest logs/events
          <Chip label="Real time logs/events" style={{ float: 'right' }} />
        </Typography>
        <div className="table-responsive">
          <DataTable columns={columns} data={data} pagination persistTableHead />
        </div>
      </CardContent>
    </Card>
  );
}

export default pitLogs;
